import { type CSSObject } from '@emotion/react';
import { useTheme, type ThemeNames } from '../../../theme';

export type LinkSize = 'regular' | 'small';

type Return = Record<'container' | 'icon' | 'link', CSSObject>;

type Props = {
  themeName?: ThemeNames;
};

export const useLinkStyles = ({ themeName }: Props): Return => {
  const theme = useTheme(themeName);
  return {
    container: {
      border: 'none',
      background: 'none',
      textAlign: 'unset',
      padding: 0,
      display: 'inline-flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      color: theme.text.link.default,
      fontFamily: 'inherit',

      '&:hover, &:focus': {
        color: theme.text.link.hover,
        cursor: 'pointer',
      },

      '&:disabled': {
        cursor: 'not-allowed',
        color: theme.text.link.disabled,
      },

      '&:focus-visible': {
        outline: `2.5px solid ${theme.button.focused.default}`,
        outlineOffset: -2.5,
      },
    },
    icon: {
      flexShrink: 0,
      marginTop: 1,
    },
    link: {
      textDecoration: 'underline',
    },
  };
};
